<template>
  <div class="hero-image">
    <figure class="hero-image__ratio">
      <img :src="getImage" alt="Alt description for the image">
    </figure>
  </div>
</template>

<script>
export default {
  name: 'HeroImage',
  components: {},
  props: {
    image: {
      type: String,
      default: 'morrisons-4-3-ratio.jpg'
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    }
  }
}
</script>

<style lang="postcss">
.hero-image {
  @apply -mx-6 px-6 pb-6 mb-6 -mt-2;
}
.hero-image__ratio {
  @apply aspect-ratio-16/9 w-full bg-body-dark relative overflow-hidden;
}
.hero-image__ratio > img {
  @apply block absolute inset-y-0 inset-x-0 min-h-full min-w-full;
  object-fit: cover;
}
@screen md {
  .hero-image {
    @apply mb-8 pb-8 pt-0;
  }
}
@screen lg {
  .hero-image {
    @apply flex-no-wrap -ml-1/7 -mt-24 mb-16 mr-0 px-0 py-0 bg-transparent;
  }
  .hero-image__ratio > img {
    @apply w-full;
  }
}
</style>